import produce from 'immer';
import * as CONSTANTS from './constants';

const initialState = {
    initialProfile: null,
    initialPost: null,
    loading: false,
    error: null
}

const buddiFeedReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case CONSTANTS.SET_INITIAL_PROFILE:
        draft.initialProfile = action.payload;
        break;
      case CONSTANTS.CLEAR_INITIAL_PROFILE:
        draft.initialProfile = null;
        break;
      case CONSTANTS.SET_INITIAL_POST:
        draft.initialPost = action.payload;
        break;
      case CONSTANTS.CLEAR_INITIAL_POST:
        draft.initialPost = null;
        break;
    }
  }
);

export default buddiFeedReducer;